import type { IconSvgObject } from './types';

const SunriseIcon: IconSvgObject = [
  ["path", { d: "M9.5 6.5L12 4L14.5 6.5M12 10V4.64033", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 10.5L17 12M7 12L5.5 10.5028", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 17H3M21 17L19 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 20H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M16 17C16 14.7909 14.2091 13 12 13C9.79086 13 8 14.7909 8 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default SunriseIcon;
